// extracted by mini-css-extract-plugin
module.exports = {"check":"styles_check__3l5-Q"};